<template>
  <transition name="el-zoom-in-top">
    <div class="content-wrapper">
      <section class="content-header">
        <ol class="breadcrumb">
          <li>
            <router-link to="/">
              <i class="ti-home"></i>
            </router-link>
          </li>
          <li>
            <router-link :to="{name:'devices'}">Devices</router-link>
          </li>
          <li class="active">
            <a href="#">Stream</a>
          </li>
        </ol>
      </section>
      <section class="content">
        <!-- Basic Tables-->
        <div class="box" v-loading="loading && !videos.length">
          <div class="box-body">
            <el-row v-for="(row,row_index) in grid" :key="`row${row_index}`">
              <el-col
                v-for="(video,column_index) in row"
                :key="`row${column_index}`"
                :md="24"
                :lg="12"
              >
                <Player :src="video"/>
              </el-col>
            </el-row>
          </div>
        </div>
      </section>
    </div>
  </transition>
</template>
<script>
import Player from "./Player.vue";
import { videoClient } from "@api/video";

export default {
  components: {
    Player
  },
  props: {
    serial: {
      required: true
    }
  },
  data() {
    return {
      loading: false,
      componentDestroyed: false,
      streamUrls: {},
      keepAliveTimer: null,
      bootstrapTimer: null,
    };
  },
  computed: {
    channels() {
      const { channels } = this.$route.query;
      return  (Array.isArray(channels) ? channels : [channels])
          .map(x => parseInt(x))
          .filter(x => Number.isInteger(x))
          .sort();
    },
    videos() {
      return this.channels
        .map(ch => this.streamUrls[ch])
        .filter(x => !!x);
    },
    grid() {
      const count = this.videos.length;
      let result = [];

      for (let i = 0; i < count; i++) {
        const video = this.videos[i];
        if (i % 2 === 0) {
          result.push([video]);
        } else {
          result[result.length - 1].push(video);
        }
      }
      return result;
    }
  },
  watch: {
    channels: {
      immediate: true,
      handler(val) {
        val.forEach(ch => {
          if(this.streamUrls[ch] === undefined) {
            this.$set(this.streamUrls, ch, null);
          }
        })
      }
    }
  },
  methods: {
    requestLiveStream() {
      if(!this.channels.length) return;
      if(this.loading) return;
      this.loading = true;
      videoClient.requestLiveStream(this.serial, this.channels)
        .then(({data: {status, hlsStreamUrls}}) => {
          this.loading = false;
          if(status === 'FAIL') {
              this.$notify.error({
                title: 'Error',
                message: 'Unable to request the live stream for all of requested channels'
              });
          } else if(status === 'PARTIAL_SUCCESS') {
              this.$notify.warning({
                title: 'Warning',
                message: 'Unable to request the live stream for some of requested channels'
              })
          }
          Object.keys(hlsStreamUrls).forEach(ch => {
            this.streamUrls[ch] = hlsStreamUrls[ch];
          })
        })
        .catch(error => {
          this.loading = false;
          if(error.response) {
            const status = error.response.status;
            if(status === 503) {
              this.$notify.error({
                title: 'Error',
                message: 'Unable to request the live stream because the device unavailable'
              });
            }
          }
        });
    }
  },
  mounted() {
    this.requestLiveStream();

    // Regular keep-alive for already-started streams.
    this.keepAliveTimer = setInterval(() => {
      if(this.componentDestroyed) return;
      this.requestLiveStream();
    }, 15000);

    // Faster bootstrap retries until first stream URL appears.
    this.bootstrapTimer = setInterval(() => {
      if(this.componentDestroyed) return;
      if(this.videos.length > 0) {
        clearInterval(this.bootstrapTimer);
        this.bootstrapTimer = null;
        return;
      }
      this.requestLiveStream();
    }, 3000);
  },
  beforeDestroy() {
    this.keepAliveTimer && clearInterval(this.keepAliveTimer);
    this.bootstrapTimer && clearInterval(this.bootstrapTimer);
    this.componentDestroyed = true;
  }
};
</script>



// WEBPACK FOOTER //
// Stream.vue?7f321436